var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import Component from "vue-class-component";
import { Dependencies } from "~/core/decorator";
import { AssistCollectionCaseService } from "~/services/domain-service/assist-collection-case.service";
import { Emit, Prop } from "vue-property-decorator";
import { PageService } from "~/utils/page.service";
import { SortService } from "~/utils/sort.service";
import { UserService } from "~/services/manage-service/user.service";
import { PrincipalService } from "~/services/manage-service/principal.service";
import DataBox from "~/components/common/data-box.vue";
var AssistManageCollecting = /** @class */ (function (_super) {
    __extends(AssistManageCollecting, _super);
    function AssistManageCollecting() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loading = {
            state: false,
        };
        _this.nowNode = null;
        _this.caseList = []; // 案件数组
        _this.manualModel = {
            batchNum: "",
            closeDate: "",
            companyCode: "",
            type: "",
        };
        _this.assistDataSet = [];
        _this.searchModel = {
            assistStatus: "",
            assistLocalFlag: "OFFSITE_OUT_ASSIST",
        };
        _this.selectionList = [];
        return _this;
    }
    AssistManageCollecting.prototype.refreshList = function () { };
    AssistManageCollecting.prototype.close = function () { };
    AssistManageCollecting.prototype.approvedMeth = function (rowData) { };
    /**
     * 选择点变化
     */
    AssistManageCollecting.prototype.getCheckedNodes = function (item) {
        this.nowNode = item;
        this.refreshData();
    };
    /**
     * 刷新
     */
    AssistManageCollecting.prototype.refresh = function (caseList) {
        this.caseList = caseList;
        // this.nowNode = null
        // let tree: any = this.$refs.tree
        // tree.reset()
    };
    /**
     * 刷新用户列表
     */
    AssistManageCollecting.prototype.refreshData = function () {
        var _this = this;
        var searchModel = Object.assign(this.searchModel, this.assistModel);
        searchModel.assistStatus = "ASSIST_COLLECTING"; //协调中
        this.assistCollectionCaseService.searchAssistCase(searchModel, this.pageService, this.sortService, this.loading).subscribe(function (data) {
            _this.assistDataSet = data;
        }, function (_a) {
            var msg = _a.msg;
        });
    };
    //审批操作
    AssistManageCollecting.prototype.approvedAssistMeth = function (scope) {
        var rowData = scope.row;
        this.approvedMeth(rowData);
    };
    __decorate([
        Dependencies(PageService)
    ], AssistManageCollecting.prototype, "pageService", void 0);
    __decorate([
        Dependencies(SortService)
    ], AssistManageCollecting.prototype, "sortService", void 0);
    __decorate([
        Dependencies(UserService)
    ], AssistManageCollecting.prototype, "userService", void 0);
    __decorate([
        Dependencies(PrincipalService)
    ], AssistManageCollecting.prototype, "principalService", void 0);
    __decorate([
        Dependencies(AssistCollectionCaseService)
    ], AssistManageCollecting.prototype, "assistCollectionCaseService", void 0);
    __decorate([
        Emit("refreshList")
    ], AssistManageCollecting.prototype, "refreshList", null);
    __decorate([
        Emit("close")
    ], AssistManageCollecting.prototype, "close", null);
    __decorate([
        Emit("approvedMeth")
    ], AssistManageCollecting.prototype, "approvedMeth", null);
    __decorate([
        Prop()
    ], AssistManageCollecting.prototype, "assistModel", void 0);
    AssistManageCollecting = __decorate([
        Component({
            components: {
                DataBox: DataBox,
            },
        })
    ], AssistManageCollecting);
    return AssistManageCollecting;
}(Vue));
export default AssistManageCollecting;
